import {FbFormObject} from '../class/fb_form_object';

export class WikiLink extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'swl_name', label: 'Name', visible: true, noclick: false, disable_ripple: true},
            {id: 'swl_url', label: 'Link', visible: true, noclick: false, disable_ripple: true},
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'Wiki Links to https://starcitizen.tools/',
                class: 'card card-1 padding single-column',
                field_class: '',
                fields: [
                    {
                        type: 'text',
                        name: 'swl_name'
                    },
                    {
                        type: 'text',
                        name: 'swl_url'
                    }
                ]
            }
        ];
        super.setEditFields();
    }

    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.stores['wiki_link'] = this.storeService.getStore('wiki_link');

            this.main_store = this.stores['wiki_link'];
            const stores = [];
            stores.push(this.stores['wiki_link'].loadStore(this.filter));
            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        return {
            data: {
                swl_name: '',
                swl_url: 'https://starcitizen.tools/'
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        // call super
        super.setSelectboxes();
    }

}
